import React from 'react';

import { Upload, FileText, Send, BarChart3 } from 'lucide-react';



const Stat = ({ label, value, delta }) => (
  <div className="bg-white rounded-3xl p-6 border border-gray-100 shadow-sm">
    <p className="text-xs uppercase tracking-wide text-gray-500">{label}</p>
    <div className="flex items-end gap-3 mt-2">
      <p className="text-3xl font-bold">{value}</p>
      <span className={`text-xs ${delta?.startsWith("+") ? "text-green-600" : "text-rose-600"}`}>{delta}</span>
    </div>
  </div>
);

const QuickAction = ({ icon: IconComponent, label, description }) => (
  <button className="w-full border border-gray-200 rounded-2xl p-4 text-left hover:shadow-sm hover:-translate-y-0.5 transition bg-white">
    <div className="flex items-center gap-3">
      <div className="h-9 w-9 rounded-xl bg-gray-900 text-white grid place-items-center">
        <IconComponent size={18} />
      </div>
      <div>
        <p className="font-medium">{label}</p>
        <p className="text-xs text-gray-500">{description}</p>
      </div>
    </div>
  </button>
);

const Card = ({ title, right, children }) => (
  <div className="bg-white rounded-3xl shadow-md border border-gray-100 p-6">
    <div className="flex items-center justify-between mb-4">
      <h3 className="text-lg font-semibold">{title}</h3>
      {right}
    </div>
    {children}
  </div>
);

function DashboardView() {
  const statsData = [
    { label: "Releases This Month", value: "12", delta: "+3" },
    { label: "Avg. Open Rate", value: "34%", delta: "+2%" },
    { label: "Pickup Confirmed", value: "47", delta: "+11" },
    { label: "Top Region", value: "Southeast", delta: "," },
  ];

  const recentReleases = [
    { title: "Book Launch: Coloring Odyssey", status: "Scheduled", time: "Nov 12", statusColor: "bg-amber-50 text-amber-700" },
    { title: "Artist Single: HXZE – Nova", status: "Distributed", time: "Nov 2", statusColor: "bg-green-50 text-green-700" },
    { title: "App Update: StoryScape XR", status: "Draft", time: "Nov 1", statusColor: "bg-gray-100 text-gray-700" },
  ];

  const topOutlets = [
    { name: "WRFG (Atlanta)", type: "Radio" },
    { name: "Pitchfork", type: "Blog" },
    { name: "IssueWire", type: "PR" },
    { name: "PRLog", type: "PR" },
  ];

  return (
    <div className="grid gap-6">
      <div className="grid md:grid-cols-4 gap-4">
        {statsData?.map((stat, index) => (
          <Stat key={index} label={stat?.label} value={stat?.value} delta={stat?.delta} />
        ))}
      </div>
      <div className="grid lg:grid-cols-3 gap-6">
        <Card title="Quick Actions">
          <div className="grid sm:grid-cols-2 gap-3">
            <QuickAction icon={Upload} label="Upload Release" description="Start a new workflow" />
            <QuickAction icon={FileText} label="Write w/ AI" description="Generate content with AI" />
            <QuickAction icon={Send} label="Plan Distribution" description="Set up campaign" />
            <QuickAction icon={BarChart3} label="View Reports" description="Analytics dashboard" />
          </div>
        </Card>

        <Card title="Recent Releases">
          <ul className="space-y-3">
            {recentReleases?.map((release, index) => (
              <li key={index} className="flex items-center justify-between">
                <div>
                  <p className="font-medium">{release?.title}</p>
                  <p className="text-xs text-gray-500">{release?.status} • {release?.time}</p>
                </div>
                <span className={`text-xs px-2 py-1 rounded-full ${release?.statusColor}`}>
                  {release?.status}
                </span>
              </li>
            ))}
          </ul>
        </Card>

        <Card title="Top Outlets">
          <ul className="space-y-2 text-sm">
            {topOutlets?.map((outlet, index) => (
              <li key={index} className="flex items-center justify-between">
                <span>{outlet?.name}</span>
                <span className="text-gray-500">{outlet?.type}</span>
              </li>
            ))}
          </ul>
        </Card>
      </div>
    </div>
  );
}

export default DashboardView;